var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrontendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,32a1,1,0,0,0-.757-.97L40.7,30.4l1.347-2.244a1,1,0,0,0-.151-1.222L39.071,24.1a1,1,0,0,0-1.222-.151L35.6,25.3l-.635-2.54A1,1,0,0,0,34,22H30a1,1,0,0,0-.97.757L28.4,25.3,26.151,23.95a1,1,0,0,0-1.222.151L22.1,26.929a1,1,0,0,0-.151,1.222L23.3,30.4l-2.54.635A1,1,0,0,0,20,32v4a1,1,0,0,0,.757.97l2.54.635L21.95,39.849a1,1,0,0,0,.151,1.222L24.929,43.9a1,1,0,0,0,1.222.151L28.4,42.7l.635,2.54A1,1,0,0,0,30,46h4a1,1,0,0,0,.97-.757L35.6,42.7l2.244,1.347a1,1,0,0,0,1.222-.151L41.9,41.071a1,1,0,0,0,.151-1.222L40.7,37.6l2.54-.635A1,1,0,0,0,44,36Zm-2,3.219-2.788.7a1,1,0,0,0-.69.609.8.8,0,0,1-.045.093c-.032.062-.063.125-.092.19a1,1,0,0,0,.058.917l1.49,2.484-1.724,1.724-2.477-1.486a1,1,0,0,0-.92-.057l-.286.109a1,1,0,0,0-.6.688L33.219,44H30.781l-.7-2.788a1,1,0,0,0-.609-.69.8.8,0,0,1-.093-.045c-.062-.032-.125-.063-.19-.092a1,1,0,0,0-.917.058l-2.484,1.49-1.724-1.724,1.486-2.477a1,1,0,0,0,.057-.92l-.109-.286a1,1,0,0,0-.688-.6L22,35.219V32.781l2.806-.7a1,1,0,0,0,.69-.609l.124-.272a1,1,0,0,0-.058-.917l-1.5-2.491,1.724-1.724,2.476,1.485a.994.994,0,0,0,.919.057l.142-.065c.048-.023.1-.046.146-.066a1,1,0,0,0,.61-.69l.7-2.788h2.438l.7,2.788a1,1,0,0,0,.609.69.8.8,0,0,1,.093.045c.062.032.125.063.19.092a1,1,0,0,0,.917-.058l2.484-1.49,1.724,1.724-1.486,2.477a1,1,0,0,0-.057.92l.109.286a1,1,0,0,0,.688.6l2.813.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,46H8v5a1,1,0,0,0,1,1H41.051A10,10,0,1,0,52,41.051V9a1,1,0,0,0-1-1H46V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3V45A1,1,0,0,0,3,46Zm7,4V18H50V41.051A10.015,10.015,0,0,0,41.051,50Zm49,1a8,8,0,1,1-8-8A8.009,8.009,0,0,1,59,51ZM50,10v6H10V10H50ZM4,4H44V8H9A1,1,0,0,0,8,9v1H4Zm0,8H8V44H4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 12,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 16,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 20,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 46,
    y: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.293,51.707l3,3,1.414-1.414L48.414,52h5.172l-1.293,1.293,1.414,1.414,3-3a1,1,0,0,0,0-1.414l-3-3-1.414,1.414L53.586,50H48.414l1.293-1.293-1.414-1.414-3,3A1,1,0,0,0,45.293,51.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,30a4,4,0,1,0,4,4A4,4,0,0,0,32,30Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,32,36Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontendIcon);
export default __webpack_public_path__ + "static/media/frontend-icon.e45617fc869353b9fcebc69e7f11824c.svg";
export { ForwardRef as ReactComponent };